import { AEMScenes } from '@as-react/common-types';
import { searchReducer } from '../../search/reducers/SearchReducer';
import searchSaga from '../../search/sagas/SearchSagas';
const loadSearchModule = () => ({
    id: AEMScenes.SEARCH_MENU_ITEM,
    reducerMap: {
        search: searchReducer,
    },
    sagas: [searchSaga],
});
export default loadSearchModule;
